import {SystemBaseApi} from "./SystemBaseApi";
import {Methods} from '@newview/infrastructure';

/**
 * Api
 */
export class FileinforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'fileinfor'
    }


    /**
     * 查询附件列表
     * @returns 
     */
    public getFileListByUserIcon(fileInfoVos) {
        return this.send(fileInfoVos, "getFileListByUserIcon", Methods.POST)
    }

    /**
     * 查询附件列表
     * @returns 
     */
    public getEntityByToken(token) {
        return this.send({ token: token }, "getEntityByToken", Methods.GET)
    }

    /**
     * 单个文件上传
     * @param groupName
     * @param data
     * @param token
     */
    public fileUpload(groupName: string, data: string, token: string = '', catalogue: string) {
        return this.send({ groupName: groupName, token: token, file: data, catalogue: catalogue }, "fileUpload", Methods.POST, "Upload");
    }

    /**
     * 文件详情信息
     * @param id
     * @returns
     */
    public getInfoById(id) {
        return this.send({}, "getInfoById?id=" + id, Methods.GET);
    }
    /**
     * token查询富文本框
     * @param token 
     * @returns 
     */
    public getTextByToken(token) {
        return this.send({}, "getTextByToken?token=" + token, Methods.GET);
    }
    /**
     * token查询富文本框
     * @param token
     * @returns
     */
    public getTextByFileName(token) {
        return this.send({}, "getTextByFileName?fileName=" + token, Methods.GET);
    }
    /**
     * 富文本直接上传阿里云
     * @param text 
     * @returns 
     */
    public uploadText(text) {
        return this.send(text, "uploadText", Methods.POST)
    }

    /**
    * 富文本直接上传阿里云
    * @param text 
    * @returns 
    */
    public WriteAbsFile(text) {
        return this.send(text, "WriteAbsFile", Methods.POST)
    }

    /**
     * 删除
     * @param token
     * @constructor
     */
    public DeleteByToken(token) {
        return this.send({}, "DeleteByToken?token=" + token, Methods.GET);
    }

    /**
     *  单条保存
     * @param fileinfor
     */
    public insert(fileinfor) {
        return this.send(fileinfor, "insert", Methods.POST);
    }

    /**
     *  单条保存
     * @param fileinfor
     */
    public insertList(fileinfors) {
        return this.send(fileinfors, "insertList", Methods.POST);
    }


    /**
     *  token获取文件
     * @param fileinfor
     */
    public getTokensByFileList(tokens) {
        return this.send(tokens, "getTokensByFileList", Methods.POST);
    }
    /**
       * 富文本直接上传阿里云
       * @param text 
       * @returns 
       */
    public WriteText(param) {
        return this.send(param, "WriteText", Methods.POST)
    }

    /**
     * 获取oss凭证
     */
    public getAliOSS() {
        return this.send({}, "getAliOSS", Methods.GET)
    }

    /**
     * 查看是否有文件
     * @param token
     */
    public IsExistFile(fileName) {
        return this.send({}, "IsExistFile?fileName=" + fileName, Methods.GET);
    }

    /**
     * 各业务历史文件
     */
    public bussinessFileHistory(token){
        return this.send({token:token},"bussinessFileHistory",Methods.GET)
    }

	 /**
    * 修改附件信息
    * @param {Object} param
    */
    public update(param){
        return this.send(param,"update",Methods.POST)
    }
}
